export default __webpack_public_path__ + "static/media/planet1.3c24f446.webp";